import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthContext';
import { dashboardWidgetsForRole } from '@/pages/dashboard/dashboardRegistry';
import './DashboardPage.css';

/**
 * Role-aware dashboard shell (T85, `11-dashboard-widget-grid-ux.md`). The page owns the single
 * shared `<h1>` (§5 heading structure); `dashboardWidgetsForRole` resolves the current user's
 * widget set — Admin gets the real T81/T82 widget grid (`AdminDashboardGrid`), every other role
 * keeps the pre-existing placeholder (`PlaceholderDashboardWidgets`) unchanged.
 */
export function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const WidgetSet = dashboardWidgetsForRole(user?.role);

  return (
    <section className="fa-dashboard">
      <h1 className="fa-dashboard__title">{t('dashboard.title')}</h1>
      <WidgetSet />
    </section>
  );
}
